import { z } from "zod"
import { PartGrade } from "./part-grade"

export const PartGradeDescriptionsSchema = z.partialRecord(
  z.nativeEnum(PartGrade),
  z.string(),
)

export type PartGradeDescriptions = z.infer<typeof PartGradeDescriptionsSchema>
